module.exports = __webpack_public_path__ + "img/treatment-pills.f02ffd3f.svg";